export default __webpack_public_path__ + "static/media/canDo.5e4fa4ab.webp";